import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Flex, Box } from '../../../units/Box/Box';
import Text from '../../../units/Text/Text';

const Wrapper = styled(Box)`
  position: relative;
`;

const StepTitleBox = styled(Flex).attrs({
  height: '32px',
  width: '32px',
  justify: 'center',
  align: 'center'
})`
  background: ${props =>
    props.active ? props.theme.colors.brand : props.theme.colors.white};
  color: ${props =>
    props.active ? props.theme.colors.white : props.theme.colors.greyLight};
  border: 1px solid
    ${props =>
      props.active ? props.theme.colors.white : props.theme.colors.greyLight};
  border-radius: 100%;
`;

const StepTitle = styled(Text).attrs({
  size: '19px',
  bold: true
})``;

const StepLabelBox = styled(Box)`
  position: absolute;
  width: 300px;
  left: -134px;
  bottom: -23px;
  text-align: center;
`;

const StepLabel = styled(Text).attrs({
  font: 'caption'
})`
  color: ${props =>
    props.active ? props.theme.colors.brand : props.theme.colors.greyLight};
`;

const Step = ({ step, label, activeStep }) => {
  const isPassedStep = step <= activeStep;
  const isActiveStep = step === activeStep;

  return (
    <Wrapper
      className={`registration-step ${isActiveStep &&
        'registration-step_active'}`}
    >
      <StepTitleBox className="registration-step__number" active={isPassedStep}>
        <StepTitle>{step}</StepTitle>
      </StepTitleBox>

      <StepLabelBox className="registration-step__label">
        <StepLabel active={isPassedStep}>{label}</StepLabel>
      </StepLabelBox>
    </Wrapper>
  );
};

Step.propTypes = {
  step: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  activeStep: PropTypes.number.isRequired
};

export default Step;



// WEBPACK FOOTER //
// ./src/components/containers/NewClient/RegistrationSteps/Step.js